import { DeploymentType, WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import _ from 'lodash';
import {
	addDefaultFeatureCanariesForOnPrem,
	captureConfigurationsFromPlugin,
} from 'Configuration/utils';

const handleCommonDefaults = (_configuration: WorkspaceConfiguration) => {};

const handleDefaultsForOnPrem = (_configuration: WorkspaceConfiguration) => {
	_configuration.deploymentType = DeploymentType.OnPrem;
	addDefaultFeatureCanariesForOnPrem(_configuration);
	captureConfigurationsFromPlugin(_configuration);
};

const handleDefaultsForCloud = (_configuration: WorkspaceConfiguration) => {
	_configuration.deploymentType = DeploymentType.Cloud;
};

export const handleConfigurationDefaults = (configuration: WorkspaceConfiguration) => {
	handleCommonDefaults(configuration);
	if (IS_ON_PREM) {
		handleDefaultsForOnPrem(configuration);
	} else {
		handleDefaultsForCloud(configuration);
	}
	return configuration;
};
